export default {"src":"https://www.azblue.com/_next/static/media/AZ_Blue_Logo.64f07e4b.svg","height":40,"width":158};